export enum BankAccountApplicationDocumentTypeEnum {
	UNKNOWN = "Unknown",
	PAYMENT_ACCEPT_AGREEMENT = "PaymentAcceptAgreement",
	INFORMATIONAL_LETTER = "InformationalLetter",
	DIRECT_WITHDRAWAL_AGREEMENT = "DirectWithdrawalAgreement",
	LEGAL_DEPARTMENT_REQUEST_DOCUMENT = "LegalDepartmentRequestDocument"
}